import { render, staticRenderFns } from "./ButtonSubmit.vue?vue&type=template&id=6c3ee30e&scoped=true"
import script from "./ButtonSubmit.vue?vue&type=script&lang=ts"
export * from "./ButtonSubmit.vue?vue&type=script&lang=ts"
import style0 from "./ButtonSubmit.vue?vue&type=style&index=0&id=6c3ee30e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3ee30e",
  null
  
)

export default component.exports